import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "triangle-down",
  "use": "triangle-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"triangle-down\"><path d=\"M5 6h10l-5 9-5-9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/triangle-down.svg
// module id = Dby3
// module chunks = 1